import { Link } from "react-router-dom";

interface ArticleHeroProps {
  image: string;
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  views: number;
  author: string;
  authorAvatar: string;
}

export default function ArticleHero({
  image,
  title,
  category,
  categorySlug,
  date,
  views,
  author,
  authorAvatar,
}: ArticleHeroProps) {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img
        src={image}
        alt={title}
        title={`${title} - 黑料网`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/55"></div>

      <div className="absolute bottom-0 left-0 right-0 px-6 md:px-10 pb-10 md:pb-14">
        <div className="max-w-[900px] mx-auto w-full">
          <Link
            to={`/category/${categorySlug}`}
            className="inline-flex items-center px-3 py-1 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-semibold rounded-md mb-4 hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            {category}
          </Link>

          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
            {title}
          </h1>

          <div className="flex flex-wrap items-center gap-4 md:gap-6 text-white/75">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full overflow-hidden bg-background-300/40">
                <img
                  src={authorAvatar}
                  alt={author}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-sm font-medium text-white/90">{author}</span>
            </div>
            <div className="w-px h-4 bg-white/20 hidden sm:block"></div>
            <span className="flex items-center gap-1.5 text-sm">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-1.5 text-sm">
              <i className="ri-eye-line"></i>
              {views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views} 阅读
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}